import { IFilterInduccionPorVencerModel } from '../interfaces/induccion/IFilterInduccionPorVencerModel';

export class FilterInduccionPorVencerModel implements IFilterInduccionPorVencerModel {
  nombreEmpleado: string;
  nroDocumento: string;
  codigoSolicitud: string;
  nombreContratista: string;
  sedes: number[];
  solicitante: string;
  fechaInicio?: Date;
  fechaFin?: Date;
  page: number;
  pageSize: number;
  idCompania: number;

  constructor() {
    this.nombreEmpleado = '';
    this.nroDocumento = '';
    this.codigoSolicitud = '';
    this.nombreContratista = '';
    this.sedes = [];
    this.solicitante = '';
    // this.fechaInicio = new Date();
    // this.fechaFin = new Date();
    this.pageSize = 30;
    this.page = 1;
    this.idCompania = 0;
  }
}
